import { formatDate } from '@/utils/date'

type NewsList = readonly { publishDate: string }[]

export const getYearList = <T extends NewsList>(list: T): readonly string[] => {
  const yearList = [
    ...new Set(list.map(({ publishDate }) => formatDate(publishDate, 'yyyy'))),
  ]
  yearList.sort((a, b) => Number(b) - Number(a))

  return yearList
}

export const getYearOptions = <T extends NewsList>(list: T) => {
  const yearList = getYearList(list)
  const yearOptions = yearList.map((y) => ({ value: y, text: `${y}` }))

  return [{ value: '', text: 'Year' }, ...yearOptions] as const
}

export const monthOptions = [
  { value: '', text: 'Month' },
  { value: '1', text: '1月' },
  { value: '2', text: '2月' },
  { value: '3', text: '3月' },
  { value: '4', text: '4月' },
  { value: '5', text: '5月' },
  { value: '6', text: '6月' },
  { value: '7', text: '7月' },
  { value: '8', text: '8月' },
  { value: '9', text: '9月' },
  { value: '10', text: '10月' },
  { value: '11', text: '11月' },
  { value: '12', text: '12月' },
] as const
